import React from 'react'
import Hero from '../../components/Hero';
import { useIntl } from 'react-intl';
import NOMLinkBoxRow from '../../components/NOMLinkBoxRow';

export type NOM_001_SCFI_2018Props = {};

const NOM_001_SCFI_2018: React.FC<NOM_001_SCFI_2018Props> = () => {
  const intl = useIntl();
  return (
    <div className="w-full flex flex-col">
      <Hero 
        bgImage={'/img/electronics-rs.jpg'} 
        heading={intl.formatMessage({
          id: "electronics",
          defaultMessage: "Electronics"
        })}
        subHeading={"NOM-001-SCFI-2018"} />
      <NOMLinkBoxRow />
      <div className="content !px-4 md:!px-2 lg:!px-0 !py-6 !pt-8">
        <h2 className="text-2xl text-secondary font-bold">NOM-001-SCFI-2018</h2>
        <div className="flex flex-col gap-4 mt-4 mb-16">
          <p>
            {
              intl.formatMessage({
                id: 'nom001scfi2018_1',
                defaultMessage: 'Electronic Devices - Safety Requirements and Test Methods'
              })
            }
          </p>
          <p>
            {
              intl.formatMessage({
                id: 'nom001scfi2018_2',
                defaultMessage: 'Electronic equipment and its accessories that use public service electrical energy for power, with single-phase supply voltages up to 277 V a.c. at 60 Hz and/or three-phase voltages up to 480 V a.c. between lines at 60 Hz; as well as other energy sources, such as cells, batteries, accumulators, self-generation and alternative power sources up to 500 V d.c.'
              })
            }
          </p>
          <p>
            {
              intl.formatMessage({
                id: 'nom001scfi2018_3',
                defaultMessage: 'New, second-line, discontinued, rebuilt, reconditioned, used or second-hand electronic equipment and/or systems; that use both electrical energy from public networks and other energy sources such as cells, batteries or accumulators for their power.'
              })
            }
          </p>
          <p>
            {
              intl.formatMessage({
                id: 'nom001scfi2018_4',
                defaultMessage: 'External power supplies, which are used in conjunction with the electronic equipment contemplated in this Official Mexican Standard or within the field of application of NOM-019-SCFI-1998, in both cases for use in direct current supplies up to 250 V and in alternating current supplies up to 480 V at 60 Hz.'
              })
            }
          </p>
        </div>
        <h2 className="text-2xl text-secondary font-bold mb-8">
          {
            intl.formatMessage({
              id: 'mcb_scope',
              defaultMessage: 'Mexico Certifying Body has the following scope:'
            })
          }
        </h2>
        <div className='flex flex-col md:flex-row items-start md:items-center md:justify-center mb-0 md:mb-6'>
          <div className="w-full flex flex-col gap-4 max-w-sm mb-6 md:mb-0">
            <div className="w-full">
              <h4 className='font-bold'>
                NMX-I-60065-NYCE-2015.
              </h4>
              <p>
                {
                  intl.formatMessage({
                    id: 'av_equip',
                    defaultMessage: 'Audio and Video Equipment'
                  })
                }
              </p>
            </div>
            <div className="w-full">
              <h4 className='font-bold'>
                NMX-I-60335-2-82-NYCE-2015. 
              </h4>
              <p>
                {
                  intl.formatMessage({
                    id: "amuse_machines",
                    defaultMessage: "Amusement machines"
                  })
                }
              </p>
            </div>
            <div className="w-full">
              <h4 className='font-bold'>
                NMX-I-163-NYCE-2016.
              </h4>
              <p>
                {
                  intl.formatMessage({
                    id: "eups",
                    defaultMessage: "Electronic Uninterruptible Power Systems"
                  })
                }
              </p>
            </div>
            <div className="w-full">
              <h4 className='font-bold'>
                NMX-I-6095-1-NYCE-2015.
              </h4>
              <p>
                {
                  intl.formatMessage({
                    id: "eps",
                    defaultMessage: "External Power Supplies"
                  })
                }
              </p>
            </div>
            <div className="w-full">
              <h4 className='font-bold'>
                NMX-J-I-62115-ANCE-NYCE-2020.
              </h4>
              <p>
                {
                  intl.formatMessage({
                    id: "elec_toys",
                    defaultMessage: "Electronic Toys"
                  })
                }
              </p>
            </div>
            <div className="w-full">
              <h4 className='font-bold'>
                NMX-I-6095-1-NYCE-2015.
              </h4>
              <p>
                {
                  intl.formatMessage({
                    id: "misc_prods",
                    defaultMessage: "Miscellaneous or Miscellaneous Products"
                  })
                }
              </p>
            </div>
          </div>
          <div className="w-full">
            <img src="/img/electronic-items-scope.jpg" alt="NOM-001-SCFI-2018 Devices" />
          </div>
        </div>
        
      </div>
    </div>
  );
}

export default NOM_001_SCFI_2018;